<template>
    <b-modal ref="modal"
             :visible="visible"
             size="sm"
             :return-focus="returnFocus"
             no-enforce-focus
             no-fade
             centered
             no-close-on-backdrop
             no-close-on-esc
             busy
             dialog-class="loading-modal">
        <div class="loading">
        </div>
    </b-modal>
</template>

<script>
  export default {
    name: 'LoadingModal',
    props: {
      visible: {
        type: Boolean,
        required: true
      },

      returnFocus: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
      }
    },

    methods: {
      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style>
    @-webkit-keyframes spinAround {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }
    @keyframes spinAround {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    .loading-modal .modal-header, .loading-modal .modal-footer {
        display: none;
    }

    .loading-modal .modal-dialog {
        max-width: 48px;
        max-height: 48px;
    }

    .loading-modal .modal-content {
        background-color: transparent;
        border: 0px;
    }

    .loading-modal .modal-body {
        padding: 0px;
    }

    .loading {
        color: transparent !important;
        pointer-events: none;
        width: 3rem;
        height: 3rem;
        font-size: 3rem;

    }

    .loading:after {
        -webkit-animation: spinAround 500ms infinite linear;
        animation: spinAround 500ms infinite linear;
        border: 4px solid white;
        border-radius: 290486px;
        border-right-color: transparent;
        border-top-color: transparent;
        content: "";
        display: block;
        height: 1em;
        position: relative;
        width: 1em;
        position: absolute;
        left: calc(50% - (1em / 2));
        top: calc(50% - (1em / 2));
        position: absolute !important;
    }
</style>
